<!-- Message: voice -->
<div (deferLoad)="voicePlayerInit()" *ngIf="voice" class="voice-content d-block">
  <div [class.d-flex]="!voiceText">
    <button
      [style.height.px]="56"
      tooltip="Распознать в текст"
      *ngIf="!voiceText && !isLoadText"
      class="btn btn-sm btn-secondary"
      (click)="recognitionAudio()"
    >
      <i-feather name="eye" class="icon-md"></i-feather>
    </button>
    <!--<div id="player-{{voice.file_id}}"></div>-->
    <div #player class="player-{{ voice.file_id }} green-audio-player">
      <audio *ngIf="voice.file_uri">
        <source src="{{ voice.file_uri }}" type="audio/ogg" />
      </audio>
    </div>
  </div>
  <div class="voice-text">
    <div *ngIf="isLoadText" class="mt-3 mb-2 text-center voice-loader">
      <div class="loader-line"></div>
    </div>
    <div *ngIf="voiceText" class="bg-white shadow-sm px-4 py-3">{{ voiceText }}</div>
  </div>
</div>
